import React from 'react';
import 'antd/dist/antd.css';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    waitingIcon,
    cancelIcon,
    confirmedIcon
} from '../../assets/images/icons';
import { PAYMENT_STATUS } from '../../redux/Constants';

const PaymentStatus = ({ status }) => {
    const { t, i18n } = useTranslation();

    let section = null;
    if (status === PAYMENT_STATUS.CANCELLED) {
        section = (
            <>
                <Icon src={cancelIcon} />
                <ItemText className="status">{i18n.t(status)}</ItemText>
            </>
        );
    }
    if (
        status === PAYMENT_STATUS.AWAITING_PAYMENT ||
        status === PAYMENT_STATUS.AWAITING_CONFIRMATION ||
        status === PAYMENT_STATUS.AWAITING_REFUND
    ) {
        section = (
            <>
                <Icon src={waitingIcon} />
                <ItemText className="status">{i18n.t(status)}</ItemText>
            </>
        );
    }
    if (status === PAYMENT_STATUS.CREATED || status === PAYMENT_STATUS.PAID) {
        section = (
            <>
                <Icon src={confirmedIcon} />
                <ItemText className="status">{i18n.t(status)}</ItemText>
            </>
        );
    }

    return <StatusContianer>{section}</StatusContianer>;
};

const StatusContianer = styled.div`
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
`;

const ItemText = styled.span`
    color: #35383f;
    font-family: AvenirNext-DemiBold;
    font-size: 12px;
    line-height: 14px;
    align-self: center;
`;

const Icon = styled.img``;

export default PaymentStatus;
